// Placeholders shaped like each page, so content fills in without the layout jumping. Screen readers
// hear one "Đang tải…" instead of the blocks.
function Block({ className = '' }) {
  return <div className={`skeleton rounded-[20px] ${className}`} />;
}

function Loading({ className = 'flex flex-col gap-4', children }) {
  return (
    <div role="status" aria-live="polite" className={className}>
      <span className="sr-only">Đang tải…</span>
      <div aria-hidden="true" className="contents">{children}</div>
    </div>
  );
}

// The day's cards under the week strip: Calo, Dinh dưỡng, Bữa ăn, Vận động.
export function DaySkeleton() {
  return (
    <Loading>
      <Block className="h-[214px]" />
      <Block className="h-[238px]" />
      <div className="flex items-center justify-between pt-1">
        <Block className="h-6 w-24 rounded-lg" />
        <Block className="h-4 w-16 rounded-lg" />
      </div>
      <Block className="h-[296px]" />
      <Block className="h-40" />
    </Loading>
  );
}

// Home's two cards under the hub: Tiếp theo and Hôm nay.
export function HomeCardsSkeleton() {
  return (
    <Loading>
      <Block className="h-[104px] bg-base-100" />
      <Block className="h-[232px] bg-base-100" />
    </Loading>
  );
}

export function PlanListSkeleton() {
  return (
    <Loading>
      <Block className="h-[360px]" />
      <Block className="mt-2 h-6 w-28 rounded-lg" />
      <Block className="h-16" />
    </Loading>
  );
}

export function PlanWeekSkeleton() {
  return (
    <Loading>
      <Block className="h-11 w-40 rounded-xl" />
      <Block className="h-8 w-56 rounded-xl" />
      <div className="flex gap-2">
        <Block className="h-9 w-36 rounded-full" />
        <Block className="h-9 w-32 rounded-full" />
      </div>
      <Block className="h-[52px] rounded-[16px]" />
      <div className="grid grid-cols-7 gap-1.5">
        {Array.from({ length: 7 }, (_, i) => <Block key={i} className="h-[58px] rounded-[14px]" />)}
      </div>
      {[0, 1, 2].map((i) => <Block key={i} className="h-[164px]" />)}
    </Loading>
  );
}

export function TrendsSkeleton() {
  return (
    <Loading>
      <div className="grid grid-cols-2 gap-3">
        {[0, 1, 2, 3].map((i) => <Block key={i} className="h-24" />)}
      </div>
      <Block className="h-72" />
      <Block className="h-60" />
    </Loading>
  );
}

export function SettingsSkeleton() {
  return (
    <Loading>
      <Block className="h-7 w-52 rounded-lg" />
      <Block className="h-[420px]" />
      <Block className="h-40" />
    </Loading>
  );
}
